<!-- src/components/OrganizationList.vue -->
<template>
    <div>
        <draggable
            :list="allOrganizations"
            @end="onDragEnd"
            handle=".drag-handle"
            item-key="orgId"
        >
            <template #item="{ element: org }">
                <OrganizationItem
                    :key="org.orgId"
                    :organization="org"
                />
            </template>
        </draggable>
    </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { Message } from '@arco-design/web-vue';
import OrganizationItem from './OrganizationItem.vue';
import draggable from 'vuedraggable';

export default defineComponent({
    name: 'OrganizationList',
    components: {
        OrganizationItem,
        draggable,
    },
    setup() {
        const store = useStore();
        const addModalVisible = ref(false);

        const allOrganizations = computed(() => store.getters['organizations/allOrganizations']);

        const fetchOrganizations = () => store.dispatch('organizations/fetchOrganizations');
        const reorderOrganizations = (orgs) => store.dispatch('organizations/reorderOrganizations', orgs);

        const showAddModal = () => {
            addModalVisible.value = true;
        };

        const onDragEnd = async () => {
            const updatedOrgs = allOrganizations.value.map((org, index) => ({
                ...org,
                sortRank: index + 1,
            }));
            try {
                await reorderOrganizations(updatedOrgs);
                Message.success('组织排序已更新');
            } catch (error) {
                console.error('组织排序更新失败:', error);
                Message.error('组织排序更新失败');
            }
        };

        onMounted(() => {
            fetchOrganizations();
        });

        return {
            allOrganizations,
            addModalVisible,
            showAddModal,
            onDragEnd,
        };
    }
});
</script>

<style scoped>
.drag-handle {
    cursor: move;
}
</style>
